export * from './aggregator.service';
import { AggregatorService } from './aggregator.service';
export * from './externalServices.service';
import { ExternalServicesService } from './externalServices.service';
export * from './processingPartner.service';
import { ProcessingPartnerService } from './processingPartner.service';
export * from './senderIdReport.service';
import { SenderIdReportService } from './senderIdReport.service';
export * from './senderIdRequest.service';
import { SenderIdRequestService } from './senderIdRequest.service';
export * from './shortCode.service';
import { ShortCodeService } from './shortCode.service';
export const APIS = [AggregatorService, ExternalServicesService, ProcessingPartnerService, SenderIdReportService, SenderIdRequestService, ShortCodeService];
